export const styles = {
  headerWithTitle: {
    backgroundColor: "events.dialogHeaderBackground",
    padding: "12px 15px 12px 20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  content: {
    backgroundColor: "events.dialogContentBackground",
    padding: "20px 24px !important",
  },
  avatar: {
    display: "inline-flex",
    verticalAlign: "middle",
    width: "50px",
  },
  contentGroup: {
    marginTop: "auto",
  },
  text: {
    display: "inline-flex",
    verticalAlign: "middle",
    marginRight: "auto",
    marginBottom: 0,
    wordBreak: "break-word",
    color: "text.primary",
    textAlign: "start",
  },
  optionalButton: {
    backgroundColor: "transparent",
    border: "1px solid events.grayTertiary",
    borderRadius: "5px",
    minWidth: "90px",
    margin: "auto",
  },
  footer: {
    backgroundColor: "events.dialogContentBackground",
    textAlign: "right",
    margin: "8px 4px",
    padding: "0 10px 10px",
  },
  footerButton: {
    textDecoration: "underline",
    display: "inline-block",
    margin: "0 4px",
    cursor: "pointer",
    color: "gray.medium",
  },
  backdrop: {
    backgroundColor: "gray.medium",
  },
  actions: {
    backgroundColor: "events.dialogContentBackground",
    gap: "10px",
    padding: "15px",
    display: "flex",
    justifyContent: "center",
    "@media (max-width: 380px)": {
      flexDirection: "column",
    },
  },
  closeIcon: {
    color: "icon.secondary",
  },
};
